import { SdkMethodPayloadInterface } from "@modules/sdk/methods/SdkMethodPayloadInterface";

import { WISHLISTS_SDK_METHODS } from "../constants";
import { WishlistsStateKit } from "../state_kit/WishlistsStateKit";

class GetWishlistsStateKitSdkMethodPayload
    implements SdkMethodPayloadInterface<WishlistsStateKit>
{
    public readonly methodName: WISHLISTS_SDK_METHODS.GET_WISHLISTS_STATE_KIT;

    constructor(
        public readonly onSuccess: (result: WishlistsStateKit) => void,
        public readonly onError: (error: Error) => void
    ) {
        this.methodName = WISHLISTS_SDK_METHODS.GET_WISHLISTS_STATE_KIT;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
}

export default GetWishlistsStateKitSdkMethodPayload;
